import { persistedWritable } from './ui';

export type CellClickMode = 'single' | 'double';

/**
 * Controls whether clicking an empty calendar cell opens the "Add Event" modal
 * on single-click or double-click. Persisted to localStorage so the preference
 * survives page reloads. Default: 'single'.
 *
 * Usage in Svelte 5 views:
 *   import { cellClickMode } from '../lib/stores/cellClick';
 *
 *   // In template — bind both, guard with mode check:
 *   onclick={(e) => { if ($cellClickMode === 'single') handleAdd(e); }}
 *   ondblclick={(e) => { if ($cellClickMode === 'double') handleAdd(e); }}
 */
export const cellClickMode = persistedWritable<CellClickMode>('cellClickMode', 'single');
